import { useCallback, useState } from 'react';
import { createBranch } from '../api/branchesApi';

const resolveErrorMessage = (error, t) => {
  const code = error?.data?.code;
  if (code === 'BRANCH_NAME_EXISTS') {
    return t('branchInitNameExists');
  }
  if (code === 'quota_exceeded' || error?.status === 429) {
    return t('branchesQuotaExceeded');
  }
  if (error?.status === 400) {
    return t('branchInitNameRequired');
  }
  return error?.data?.message || t('branchInitFailed');
};

export const useBranchInitialization = ({ token, t, onComplete }) => {
  const [name, setName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [noticeMessage, setNoticeMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleNameChange = useCallback((event) => {
    setName(event.target.value);
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      const trimmedName = name.trim();
      if (!trimmedName) {
        setErrorMessage(t('branchInitNameRequired'));
        return;
      }

      setErrorMessage('');
      setNoticeMessage('');
      setIsSubmitting(true);

      try {
        await createBranch({ name: trimmedName }, token);
        setNoticeMessage(t('branchInitSuccess'));
        setName('');
        await onComplete?.();
      } catch (error) {
        setErrorMessage(resolveErrorMessage(error, t));
      } finally {
        setIsSubmitting(false);
      }
    },
    [name, onComplete, t, token],
  );

  return {
    name,
    errorMessage,
    noticeMessage,
    isSubmitting,
    handleNameChange,
    handleSubmit,
  };
};
